module.exports = __webpack_public_path__ + "390fe2a5e8077279ebeedcf04ab921ac.svg";